<ng-container *ngIf="opened">

  <kendo-dialog class="advice-notes-dialog" [title]="referenceDataLabels.ViewAndAddAdviceNotes|localizeLabel"
    [width]="750" (close)="close()">
    <div>
      <textarea kendoTextarea [(ngModel)]="noteText" rows="6" name="noteTextarea" #noteTextarea="ngModel" maxlength="1500"
        [boiPermissionChecker]="[userPermissions.AddAdviceNote]">
      </textarea>
    </div>
    <div class="button-container">
      <button kendoButton class="primary-button" (click)="addAdviceNote()"
        [innerHtml]="referenceDataLabels.AddAdviceNote|localizeLabel" [disabled]="!noteText.trim()"
        [boiPermissionChecker]="[userPermissions.AddAdviceNote]">
      </button>
    </div>
    <div class="advice-notes-container">
      <div *ngFor="let adviceNote of adviceNotes; let isLast = last" class="message-item" [ngClass]="{'separator': !isLast}">
        <div [innerHtml]="adviceNote.Note"></div>
        <div class="message-item-footer"
          [innerHtml]="adviceNote.AddedByUser+' '+(adviceNote.DateAdded|date:'dd/MM/yyyy HH:mm')"></div>
      </div>
    </div>
  </kendo-dialog>
</ng-container>